/**
 * Remember the last flight-results URL so "Search again" (e.g. fare reprice exhausted)
 * can return the user to the same search surface they used (/search, /round-trip, etc.).
 */
export const LAST_SEARCH_URL_KEY = 'acfLastSearchUrl';

const RESULT_PREFIXES = [
  '/search',
  '/round-trip',
  '/international-round-trip',
  '/multi-city',
];

function isFlightResultsPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  return RESULT_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

export function rememberCurrentSearchUrl() {
  if (typeof window === 'undefined') return;
  try {
    const pathname = window.location.pathname;
    if (!isFlightResultsPath(pathname)) return;
    const full = pathname + (window.location.search || '');
    window.sessionStorage.setItem(LAST_SEARCH_URL_KEY, full);
  } catch {
    /* quota / private mode */
  }
}

export function getLastSearchUrl(fallback = '/search') {
  if (typeof window === 'undefined') return fallback;
  try {
    const v = window.sessionStorage.getItem(LAST_SEARCH_URL_KEY);
    if (v && typeof v === 'string' && v.startsWith('/')) return v;
  } catch {
    /* ignore */
  }
  return fallback;
}
